export default __webpack_public_path__ + "static/media/Dog5.649aad47.jpg";